export default "__VITE_ASSET__DdiwCBfO__"